<template>
    <div class="qty">
        <span @click="minus" class="minus bg-red">-</span>

        <span class="count">
            {{ countFormatted }}
        </span>

        <span @click="plus" class="plus bg-red">+</span>
    </div>
</template>

<script>
    export default {
        name: "Counter",

        props: {
            canBeNegative: {
                default: false,
                type: Boolean
            },
            canBeUserFriendly: {
                default: false,
                type: Boolean
            },
            value: {
                default: 0,
                type: Number,
                required: true
            },
            step: {
                default: 1,
                type: Number,
            },
            needFormat: {
                default: true,
                type: Boolean
            },
            fractionDigits: {
                default: 1,
                type: Number,
            },
        },

        data() {
            return {
                counter: this.value
            }
        },

        computed: {
            count() { return this.counter > 0 ? '+' + this.counter : this.counter.toString() },
            countFormatted() { return this.formatCount(this.count) },
            stepIsDecimalNumber() { return this.step % 1 !== 0 }
        },

        watch: {
            counter(value) {
                this.$emit('update:value', value)
            }
        },

        methods: {
            formatCount(float){
                return parseFloat(float).toFixed(this.fractionDigits).replace('.', ',');
            },
            minus() {
                if (this.canBeNegative || this.counter >= this.step) {
                    if (this.canBeUserFriendly && this.counter < 1 && this.counter > 0) {
                        this.counter *= -1;
                    } else {
                        this.counter -= this.step;
                    }
                }
            },

            plus() {
                if (this.canBeUserFriendly && this.counter > -1 && this.counter < 0) {
                    this.counter *= -1;
                } else {
                    this.counter += this.step;
                }
            }
        }
    }
</script>
